import { Lightbulb } from "lucide-react";

import { Button } from "@/components/ui";
import type { WhatsNewPlacement } from "@/lib/types";
import { useMarkWhatsNew, useWhatsNew } from "@/lib/whats-new";

/**
 * A one-time tip for the page it sits on. The server only sends tips about things this person can use; dismissing
 * one is remembered for them. Quiet by design: no alert, no focus change, and nothing at all if it can't load.
 */
export function FeatureTip({ placement }: { placement: WhatsNewPlacement }) {
  const feed = useWhatsNew();
  const mark = useMarkWhatsNew();
  const tip = feed.data?.items.find((i) => i.kind === "tip" && i.placement === placement);
  if (!tip) return null;
  return (
    <aside
      aria-label="Tip"
      className="flex items-start gap-3 rounded-xl border border-border bg-brand-50 px-4 py-3 print:hidden"
    >
      <Lightbulb className="mt-0.5 size-4 shrink-0 text-brand-600" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-fg">{tip.title}</p>
        <p className="mt-0.5 text-sm text-fg-muted">{tip.body}</p>
      </div>
      <Button variant="secondary" size="sm" onClick={() => mark.mutate({ ids: [tip.id], dismissed: true })}>
        Got it
      </Button>
    </aside>
  );
}
